
import { computed, defineComponent, ref, PropType } from "vue";
import { IAttributeGroup } from "@/services/Models";
import { v4 as uuid } from "uuid";
import Optiondialog from "@/components/OptionDialog.vue";

export default defineComponent({
  name: "SelectCheckboxAttribute",
  components: {
    Optiondialog,
  },
  props: {
    attributeGroup: { type: Object as PropType<IAttributeGroup> },
    selectedAttributeIDs: { type: Object as PropType<number[]> },
  },
  setup(props, context) {
    if (props.attributeGroup === undefined) return;

    const selectedList = computed({
      get: () => props.selectedAttributeIDs,
      set: (newValue) => context.emit("update:selectedAttributeIDs", newValue),
    });
    const isNotSelected = computed({
      get: () => (props.selectedAttributeIDs ?? []).length == 0,
      set: (newValue: boolean) => {
        if (newValue) {
          context.emit("update:selectedAttributeIDs", []);
        }
      },
    });

    const openOption = () => {
      isShowModal.value = true;
    };
    const isShowModal = ref(false);
    const uuidValue = uuid().toString();
    return {
      uuidValue,
      isNotSelected,
      selectedList,
      openOption,
      isShowModal,
    };
  },
});
